<template>
  <div>
    <!-- Trigger Icon or Selected Value -->
    <div @click="openDialog" style="cursor: pointer;">
      <span v-if="!displayText">🔍</span>
      <div v-else class="flex items-center justify-center w-date text-xs flex-col">
        {{ displayText }}
      </div>
    </div>

    <!-- Custom Dialog -->
    <div v-if="showDialog" class="custom-dialog-overlay" @click.self="closeDialog">
      <div class="custom-dialog">
        <!-- Dialog Header -->
        <div class="custom-dialog-header">
          <h3>{{ title }}</h3>
          <button class="close-btn" @click="closeDialog">✖</button>
        </div>

        <!-- Dialog Body -->
        <div class="custom-dialog-body">
          <div class="select-wrapper">
            <select v-model="internalValue" class="border p-1 w-full" ref="select">
              <option
                  v-for="item in selectList"
                  :key="item.id"
                  :value="item.id"
              >
                {{ "username" in item ? item.username : item.name }}
              </option>
            </select>
            <button
                v-if="internalValue"
                class="clear-btn"
                @click="clearSelection"
                title="Clear selection"
            >
              ✖
            </button>
          </div>
        </div>

        <!-- Dialog Footer -->
        <div class="custom-dialog-footer">
          <button class="cancel-btn" @click="onCancel">キャンセル</button>
          <button class="ok-btn" @click="onConfirm">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelectList",
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: "月を選択",
    },
    selectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDialog: false,
      internalValue: this.modelValue,
    };
  },
  computed: {
    displayText() {
      const selected = this.selectList.find(item => item.id === this.modelValue);
      return selected ? ("username" in selected ? selected.username : selected.name) : null;
    }
  },
  watch: {
    modelValue(newVal) {
      this.internalValue = newVal;
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
      this.internalValue = this.modelValue;
      this.$nextTick(() => {
        this.$refs.select?.focus();
      });
    },
    closeDialog() {
      this.showDialog = false;
    },
    clearSelection() {
      this.internalValue = null;
    },
    onCancel() {
      this.internalValue = '';
      this.$emit("update:modelValue", this.internalValue);
      this.closeDialog();
    },
    onConfirm() {
      this.$emit("update:modelValue", this.internalValue);
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11000;
}

.custom-dialog {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 350px;
  max-width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.3s ease-in-out;
}

.custom-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.custom-dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.custom-dialog-body {
  margin: 15px 0;
}

.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.select-wrapper select {
  flex: 1;
  padding-right: 35px;
}

.clear-btn {
  position: absolute;
  right: 15px;
  background: #ffffff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  transition: background 0.2s;
}

.clear-btn:hover {
  background: #f1f1f1;
}

.custom-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn,
.ok-btn {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background: #e74c3c;
  color: #fff;
}

.ok-btn {
  background: #2ecc71;
  color: #fff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>